import { DirectiveDescriptor } from "@mdxeditor/editor";
import { Tooltip } from "../../Tooltip";

const MentionDirectiveDescriptor: DirectiveDescriptor = {
    name: "mention",
    testNode(node) {
        return node.name === "mention";
    },
    type: "textDirective",
    attributes: ["value"],
    hasChildren: true,
    Editor: (props) => {
        return (
            <Tooltip title={props.mdastNode.attributes?.value} arrow>
                <span className="mention-directive">
                    @{props.mdastNode.children.find(n => n.type === "text").value}
                </span>
            </Tooltip>
        )
    }
};

export { MentionDirectiveDescriptor };